import fastdom from '../../libraries/fastdom.min';

;
(function (undefined) {
    Shop.Tabs.include({
        options: {
            elements: {
                $container: null,
                $tabsContainer: null
            },

            selectors: {
                container: '.product-modules.active',
                boxHeader: '.boxhead',
                boxContainer: '.innerbox',
                tabContainer: 'tab-container',
                tabs: 'product-tabs',
                tabClass: 'product-tab',
                column: '.innermain .centercol',
                boxes: '.centercol > .box:not(#box_productfull)',
                boxesTop: '.centercol > [data-boxes-side="0"]',
                boxesBottom: '.centercol > [data-boxes-side="2"]',
                facebookComments: '#box_facebookchat'
            }
        },

        initialize: function (options) {
            var self;

            self = this;
            this.constructor.setOptions(options);

            fastdom.mutate(function () {
                self.createDOM();
            });
        },

        createDOM: function () {
            var self;
            var nav;
            var tabs;
            var $tabContainer;
            var $navContainer;
            var $navUl;
            var $facebookComments;

            this.options.elements.$container = $(this.options.selectors.container);

            this.options.elements.tabsContainer = $tabContainer = $('<div />', {
                'class': this.options.selectors.tabContainer
            });

            $navContainer = $('<nav />', {
                role: 'presentation'
            }).appendTo($tabContainer);

            $navUl = $('<ul />', {
                role: 'tablist'
            }).appendTo($navContainer);

            $('<div />', {
                'class': this.options.selectors.tabs
            }).appendTo($tabContainer);

            nav = [];
            tabs = [];
            self = this;

            this.options.elements.$container.children().each(function () {
                nav.push($(this).find(self.options.selectors.boxHeader));
                tabs.push($(this).find(self.options.selectors.boxContainer));
            });

            nav.forEach(function ($el, index) {
                const isFirstElement = index === 0;

                $el.appendTo($navUl).wrap($('<li />', {
                    'class': $el.context.getAttribute('id'),
                    id: $el.context.getAttribute('id') + '_tab',
                    role: 'tab',
                    'aria-selected': isFirstElement ? 'true' : 'false',
                    'aria-controls': $el.context.getAttribute('id'),
                    tabindex: isFirstElement ? '0' : '-1'
                }));

                if (isFirstElement) {
                    $el.addClass('active');
                    
                }
            });

            $navUl.find('> li').on('click', function () {
                var $el;

                $el = $(this);

                self.handleSwitchTab($el, $navUl, self);
            });

            $navUl.find('> li').on('keydown', function (ev) {
                const $currentTab = $(this);

                if (ev.key === 'ArrowLeft' || ev.key === 'ArrowRight') {
                    self.handleArrowNavigation(ev, $currentTab, $navUl, self);
                }

                if (ev.key === 'Home') {
                    ev.preventDefault();

                    self.handleSwitchTab($navUl.children().first(), $navUl, self);
                }

                if (ev.key === 'End') {
                    ev.preventDefault();

                    self.handleSwitchTab($navUl.children().last(), $navUl, self);
                }
            });

            tabs.forEach(function ($el, index) {
                $el.appendTo($tabContainer.find('.' + self.options.selectors.tabs)).wrap($('<div />', {
                    'class': self.options.selectors.tabClass + (index !== 0 ? ' none' : ''),
                    'data-tab': $el.context.getAttribute('id'),
                    id: $el.context.getAttribute('id'),
                    role: 'tabpanel',
                    'aria-labelledby': $el.context.getAttribute('id') + '_tab',
                    tabindex: '0'
                }));
            });

            this.options.elements.$container.remove();
            $tabContainer.appendTo(this.options.selectors.column);
            $(this.options.selectors.boxesBottom).appendTo(this.options.selectors.column);
            $(this.options.selectors.boxesTop).prependTo(this.options.selectors.column);

            $facebookComments = $(this.options.selectors.facebookComments);

            if ($facebookComments.length > 0) {
                $facebookComments.appendTo(this.options.selectors.column);
            }

            return this;
        },

        handleArrowNavigation: function(ev, $currentTab, $navUl, self) {
            if (ev.key !== 'ArrowLeft' && ev.key !== 'ArrowRight') return;

            const $tabToSwitchTo = ev.key === 'ArrowLeft' ? $currentTab.prev() : $currentTab.next();

            if (!$tabToSwitchTo[0]) return;

            self.handleSwitchTab($tabToSwitchTo, $navUl, self);
        },

        handleSwitchTab: function($tabToSwitchTo, $navUl, self) {
            fastdom.mutate(function () {
                $navUl.find('> li > div').removeClass('active');
                $tabToSwitchTo.find('> div').addClass('active');
                self.switchTab($tabToSwitchTo, $navUl);
            });
        },

        switchTab: function ($tabToSwitchTo, $navUl) {
            this.options.elements.tabsContainer.find('[data-tab]').addClass('none');
            this.options.elements.tabsContainer.find('[data-tab="' + $tabToSwitchTo.attr('class') + '"]').removeClass('none');

            $tabToSwitchTo[0].focus();
            this.handleTabAria($navUl[0], $tabToSwitchTo[0]);
        },

        handleTabAria: function($ulElement, $nextTabElement) {
            [...$ulElement.children].forEach(($tab) => {
                $tab.setAttribute('aria-selected', 'false');
                $tab.setAttribute('tabindex', '-1');
            });

            $nextTabElement.setAttribute('aria-selected', 'true');
            $nextTabElement.setAttribute('tabindex', '0');
        }
    });
})();